import { render } from "./Home.vue?vue&type=template&id=0d13523b&scoped=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=0d13523b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0d13523b"

export default script